import { useMutation } from '@tanstack/react-query';
import { updateProviderPreferenceData } from '@ax/service';

export function useUpdateProviderPreferenceTemplateApi() {
  const useUpdateProviderPreferencePreferencesMutation = useMutation({
    mutationKey: ['update-provider-preference'],
    mutationFn: (data: any) => updateProviderPreferenceData(data),
    onError: (error: any) => {
      return error;
    },
  });

  return useUpdateProviderPreferencePreferencesMutation;
}
